import { Component, OnInit } from "@angular/core";

import { CustomNavController } from "src/shared/providers/navigation/custom-nav-controller";
import { Menu } from 'src/providers/menu/menu';
import { Workflows } from "src/providers/workflows/workflows";
import { WindowService } from 'src/shared/providers/window.service';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from 'src/shared/util/util';

import { WorkflowModel } from "src/models/workflow.model";


import { WorkflowPage } from 'src/pages/workflows/workflow/workflow';
import { EditWorkflowPage } from 'src/pages/workflows/edit-workflow/edit-workflow';
import { AddWorkflowPage } from 'src/pages/workflows/add-workflow/add-workflow';

@Component({
    templateUrl: 'workflows.html',
    styleUrls: ['workflows.scss'],
    standalone: false
})
export class WorkflowsPage  implements OnInit {

  isPausingUnpausingWorkflow: boolean;
  isRightSideContent: boolean;
  errorMessage: string;
  loaded: boolean;
  paramForms: any = {};
  contentHeight;
  workflows: Array<WorkflowModel>;
  workflowTemplates: any;
  filteredWorkflows: Array<WorkflowModel>;
  isSavingChange: boolean;

  constructor(
    private navCtrl: CustomNavController,
    private workflowsProvider: Workflows,
    public windowService: WindowService,
    private menu: Menu,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private util: Util
    ) {}

  async ngOnInit() {
    try {
      this.loaded = false;
      this.rightSidePanelService.setDialogPageTitle('Workflows');
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      this.menu.selectedAutomation = 'workflows';
      await this.loadWorkflows();
      this.loaded = true;
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async loadWorkflows() {
    try {
      this.workflows = await this.workflowsProvider.getWorkflows();
      this.workflowTemplates = await this.workflowsProvider.getWorkflowTemplates();
      this.filteredWorkflows = this.workflows;
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async goToWorkFlow(workflow: WorkflowModel) {
    setTimeout(async () => {
      if (this.isPausingUnpausingWorkflow) {
        return this.isPausingUnpausingWorkflow = false;
      }
      const workflowWithVersions = await this.workflowsProvider.getWorkflowWithVersions(workflow.id);
      const params = {
        workflow: workflowWithVersions
      }
      this.storage.save('workflowId', workflow.id);
      if (workflowWithVersions.published_version) {
        this.goToPage(`/automations/workflow/${workflow.id}`, params, WorkflowPage);
      } else {
        this.goToPage(`/automations/workflow/${workflow.id}/edit`, params, EditWorkflowPage);
      }
    }, 200);
  }

  addWorkflow() {
    localStorage.removeItem('newWorkflowId');
    this.storage.save('workflowId', 'new');
    this.goToPage('automations/workflow/new/edit', {}, EditWorkflowPage);
  }

  async pauseUnpauseWorkflow(selection) {
    const workflow = await this.workflowsProvider.getWorkflowWithVersions(selection.id);
    this.isPausingUnpausingWorkflow = true;
    this.isSavingChange = true;
    try {
      if (workflow.paused_at) {
        // Trying to unpause - auto-publish if no published version exists
        if (!workflow.published_version && workflow.draft_version) {
          await this.workflowsProvider.publishWorkflow(workflow.draft_version.id);
        }
        await this.workflowsProvider.unpauseWorkflow(workflow.id);
        workflow.paused_at = null;
      } else {
        // Trying to pause - always allow pausing regardless of published version
        await this.workflowsProvider.pauseWorkflow(workflow.id);
        workflow.paused_at = new Date();
      }
      setTimeout(() => {
        this.isSavingChange = false;
      }, 1000);
      setTimeout(() => {
        this.isPausingUnpausingWorkflow = false;
      }, 200);
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
      this.loadWorkflows();
    }
  }



  async addTemplate(templateId) {
    try {
      const existingIds = new Set(this.workflows.map((w) => String(w.id)));
      const payload = {
        workflow_template_id: templateId
      }
      const response = await this.workflowsProvider.addWorkflowTemplate(payload);
      let addedWorkflow = Array.isArray(response) ? response[0] : response;
      if (!addedWorkflow?.id) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const workflows = await this.workflowsProvider.getWorkflowsWithVersions();
        addedWorkflow = workflows.find((w) => !existingIds.has(String(w.id)));
      }
      this.util.showSuccess('Template Added!');
      if (addedWorkflow?.id) {
        this.storage.save('workflowId', addedWorkflow.id);
        this.goToPage(`automations/workflow/${addedWorkflow.id}/edit`, {}, EditWorkflowPage);
      } else {
        await this.loadWorkflows();
      }
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async goToPage(url, params, component) {
    if (this.isRightSideContent) {
      const isRightSidePanelAlreadyOpen = await this.storage.retrieve('dialog-right-side-open');
      if (isRightSidePanelAlreadyOpen) {
        return this.rightSidePanelService.navigateTo(url, params, component);
      } else {
        this.storage.save('dialog-right-side-open', true);
        this.storage.save('dialog-params', params);
        this.rightSidePanelService.openRightSidePanel(component);
      }
    } else {
      this.navCtrl.navigateForward(url, params);
    }
  }

}
